import axios from 'axios'

export default axios

/**
 * ajax 公共 httpRequest 方法
 * @extend axios
 * @param  {Object}   option                  配置
 * @param  {Boolean}  option.withCredentials  http 请求是否携带 cookie
 * @param  {Object}   option.headers          http 请求的 Headers
 * @param  {String}   option.type             http 请求的方式, 默认为 post
 * @param  {Object}   option.data             http 请求的参数
 * @param  {String}   option.host             http 请求的域名
 * @param  {String}   option.url              http 请求的地址
 * @param  {Function} option.progress         处理上传进度
 * @param  {Object}   option.cancelToken      用于 取消 http 请求
 * @return {Promise}
 */
export function ajax (option = {}) {
  const host = option.host || '/'

  let opt = {
    withCredentials: false
  }

  if (option.headers) {
    opt.headers = option.headers
  }

  if (option.withCredentials) {
    opt.withCredentials = option.withCredentials
  }

  opt.method = option.type || 'post'
  opt.url = /^\bhttp(s)?\b|\/\//.test(option.url) ? option.url : host + option.url

  if (option.data) {
    opt.data = option.data
  }

  if (option.cancelToken) {
    opt.cancelToken = option.cancelToken
  }

  if (typeof option.progress === 'function') {
    opt.onUploadProgress = (progressEvent) => {
      option.progress(progressEvent)
    }
  }

  return axios(opt).then(res => {
    let result
    let {code, error = {}} = res.data
    let message = ''

    code = error.code || code
    message = error.msg || ''

    if (res.status === 200) {
      // 无 code 多用于获取 json 文件等
      if (code === undefined) {
        result = res.data
      }

      // 公共处理接口的方式
      if (code === 0) {
        result = res.data.data || {}
      }
    }

    if (result) {
      return result
    }

    // 添加错误类型, api 为 1 时为可捕获的异常
    error.response = res
    error.api = 1
    error.code = code | 0
    error.message = message

    return Promise.reject(error)
  }).catch(err => {
    return Promise.reject(typeof err === 'object' && err.api ? err : {
      api: 0,
      error: err
    })
  })
}
